<template>
  <div class="available-works">
    <div class="container">
      <IntroSection
          text="Welcome to my Available Works Collection!<br><br>
          Would you like to make an inquiry or express your interest? Please feel free to reach out to me through my contact form - <a href='/contact'>Contact</a>.<br><br>
          I look forward to hearing from you soon."
      >
      </IntroSection>
      <div class="submenu">
        <button id="btn-50-150" class="selected" v-on:click="scrollToSection($event)">$50 - $200</button>
        <button id="btn-200-400" v-on:click="scrollToSection($event)">$201 - $400</button >
        <button id="btn-500-800" v-on:click="scrollToSection($event)">$401+</button >
      </div>
      <!--  Price Section $50 - $200 -->
      <div class="price-section" id="section-50-150">
        <!--  id="50-150">$50 - $150</h2> -->
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-4.jpg')"
            imageDimensions='12" x 6" x 3"'
            imageMedium="assemblage"
            imageSubstrate="mounted on board"
            imageTitle="Tall Towers"
            imagePrice="$150"
        />
       <!--  <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-49.jpg')"
            imageDimensions='17" x 20"'
            imageMedium="collage"
            imageSubstrate="art paper"
            imageTitle="bird on a limb"
            imagePrice="$200" -->
            
        />
        <!--  <FlipGrid
           :imageSrc="require('@/assets/images/misc/misc-52.jpg')"
           imageDimensions='17" x 20"'
           imageMedium="collage"
           imageSubstrate="art paper"
           imageTitle="parrot"
           imagePrice="$200"
       />
       <FlipGrid
           :imageSrc="require('@/assets/images/misc/misc-48.jpg')"
           imageDimensions='17" x 20"'
           imageMedium="collage"
           imageSubstrate="art paper"
           imageTitle="Rooster"
           imagePrice="$200" -->

       />
         <FlipGrid
             :imageSrc="require('@/assets/images/misc/misc-63.jpg')"
             imageDimensions='12" x 24"'
             imageMedium="mixed media"
             imageSubstrate="canvas panel"
             imageTitle="deer"
             imagePrice="$175"
         />
         <FlipGrid
             :imageSrc="require('@/assets/images/flowers/flowers-47.jpg')"
             imageDimensions='20" x 22"'
             imageMedium="mixed media"
             imageSubstrate="art paper, framed"
             imageTitle="Red with Blue"
             imagePrice="$175"
         />
         <FlipGrid
             :imageSrc="require('@/assets/images/misc/misc-21.jpg')"
             imageDimensions='20" x 13"'
             imageMedium="collage/mixed media"
             imageSubstrate="watercolour paper/framed"
             imageTitle="Whimsy"
             imagePrice="$60"
         />
        <FlipGrid
            :imageSrc="require('@/assets/images/houses/structures-7.jpg')"
            imageDimensions='10" x 12"'
            imageMedium="charcoal"
            imageSubstrate="paper - framed"
            imageTitle="grey roof"
            imagePrice="$55"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/houses/structures-3.jpg')"
            imageDimensions='22" x 22"'
            imageMedium="collage mixed media"
            imageSubstrate="board"
            imageTitle="some circles"
            imagePrice="$200"
            
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-20.jpg')"
            imageDimensions='16" x 20"'
            imageMedium="collage/mixed media"
            imageSubstrate="board"
            imageTitle="Grazer"
            imagePrice="$200"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/faces-63.jpg')"
            imageDimensions='12" x 35"'
            imageMedium="museum canvas"
            imageSubstrate="mixed media"
            imageTitle="Polka Dots"
            imagePrice="$200"
            tall
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/faces-53.jpg')"
            imageDimensions='30" x 13" Framed'
            imageMedium="acrylic mixed media"
            imageSubstrate="on paper"
            imageTitle="Long and Lean 2"
            imagePrice="$150"
            
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/5dfb54e0-8a67-4226-9521-5780413164a5.jpg')"
            imageDimensions='12" x 24"'
            imageMedium="mixed media"
            imageSubstrate="museum board"
            imageTitle="Redhead with stripes"
            imagePrice="$200"
        />
</div>
      <!--  Price Section $201 - $400 -->
      <div class="price-section hidden" id="section-200-400">
        <!--  <h2 id="200-400">$200 - $400</h2> -->
        <!-- <FlipGrid
             :imageSrc="require('@/assets/images/misc/misc-64.jpg')"
             imageDimensions='22" x 29"'
             imageMedium="watercolour/ink"
             imageSubstrate="paper - framed"
             imageTitle="pink flamingo"
             imagePrice="$400"
         /> -->
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/portraits-of-ladies-on-powder-room-wall--canvas-20x24-1.jpg')"
            imageDimensions='16" x 20"'
            imageMedium="acrylic"
            imageSubstrate="canvas board"
            imageTitle="Profile #1"
            imagePrice="$295"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/portraits-of-ladies-on-powder-room-wall--canvas-20x24-3.jpg')"
            imageDimensions='16" x 20"'
            imageMedium="acrylic"
            imageSubstrate="canvas board"
            imageTitle="Profile #2"
            imagePrice="$295"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/faces/portraits-of-ladies-on-powder-room-wall--canvas-20x24-2.jpg')"
            imageDimensions='16" x 20"'
            imageMedium="acrylic"
            imageSubstrate="canvas board"
            imageTitle="Profile #3"
            imagePrice="$295"
        />
      
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-2.jpg')"
            imageDimensions='16" x 16"'
            imageMedium="mixed media"
            imageSubstrate="museum board"
            imageTitle="A Boat"
            imagePrice="$220"
        />
</div>
      <!--  Price Section $401+ -->
      <div class="price-section hidden" id="section-500-800">
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-66.jpg')"
            imageDimensions='54" x 42"'
            imageMedium="acrylic"
            imageSubstrate="framed canvas"
            imageTitle="3 Chairs"
            imagePrice="$1500"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/houses/IMG_3366.jpg')"
            imageDimensions='48" x 24"'
            imageMedium="mixed media"
            imageSubstrate="museum canvas"
            imageTitle="Night Sky"
            imagePrice="$700"
            
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-83.jpg')"
            imageDimensions='12" x 30"'
            imageMedium="acrylic"
            imageSubstrate="board"
            imageTitle="fore"
            imagePrice="$500"
        />
        <FlipGrid
            :imageSrc="require('@/assets/images/misc/misc-82.jpg')"
            imageDimensions='32" x 42"'
            imageMedium="mixed media"
            imageSubstrate="framed slate"
            imageTitle="tree in front"
            imagePrice="$800"
        />
      </div>
      <BackToTopButton/>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import FlipGrid from "@/components/FlipGrid";
import IntroSection from "@/components/IntroSection";
import BackToTopButton from "@/components/BackToTopButton";

export default {
  components: {FlipGrid, BackToTopButton, IntroSection},
  data() {
    return {
      numsArray: [],
    }
  },
  created() {
    const metaDescription = this.$route.meta.metaDescription;
    document.querySelector('meta[name="description"]').setAttribute('content', metaDescription);
    const metaTitle = this.$route.meta.title;
    const titleElement = document.querySelector('title');
    titleElement.textContent = metaTitle;
  },
  methods: {
    randomize() {
      let priceSections = document.querySelectorAll('.price-section');

      priceSections.forEach((priceSection) => {
        let flipGrids = Array.from(priceSection.querySelectorAll('.flip-grid'));

        this.shuffleArray(flipGrids);

        priceSection.innerHTML = '';

        flipGrids.forEach((flipGrid, index) => {
          if (index === 0 || index % 2 === 0) {
            flipGrid.classList.add('right');
          }
          priceSection.appendChild(flipGrid);
        });

      });
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    scrollToSection(event) {
      $('.submenu button').removeClass('selected');
      event.target.classList.add('selected');

      $('.price-section').addClass('hidden');

      if(event.target.id === 'btn-50-150') {
        $('#section-50-150').removeClass('hidden');
      }
      else if(event.target.id === 'btn-200-400') {
        $('#section-200-400').removeClass('hidden');
      }
      else if(event.target.id === 'btn-500-800') {
        $('#section-500-800').removeClass('hidden');
      }
    },
    addTall() {
      let priceSections = document.querySelectorAll('.price-section');

      priceSections.forEach((priceSection) => {
        let flipGrids = priceSection.querySelectorAll('.flip-grid');
        flipGrids.forEach((flipGrid) => {
          let img = flipGrid.querySelector('.image-container .art-image');

          img.onload = function() {
            var width = img.width;
            var height = img.height;
            var aspectRatio = width / height;

            if (aspectRatio < 0.7) {
              flipGrid.classList.add('tall');
            }
          };
        });
      });
    }
  },
  mounted() {
    this.randomize();
    this.addTall();
  },
}
</script>
<style lang="scss">
.available-works {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.5rem;
  display: flex;
  flex-direction: column;

  @include for-tablet-portrait-down {
    padding-top: 0;
  }
  @include for-phone-only {
    padding-top: 1.5rem;
  }

  .container {
    padding: 0 !important;

    .intro {
      background-color: #f5f4f0;
      padding: 20px 0;

      .container {
        padding: 0 1.5rem !important;
      }

      a {
        font-weight: bold;
        color: black;

        &:hover {
          color: #2c3e50;
        }
      }
    }

    .submenu {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4rem;
      margin-top: 4rem;
      gap: 3rem;

      @include for-phone-only {
        gap: 2.5rem;
      }

      button {
        color: #2c3e50;
        background-color: white;
        border: none;
        font-size: 18px;
        font-family: Lato, sans-serif;
        font-weight: 400;
        padding-left: 0;
        padding-right: 0;
        cursor: pointer;
        transition: font-weight .4s ease;
        position: relative;

        @include for-phone-only {
          font-size: 15px;
        }

        &::after {
          content: "";
          position: absolute;
          height: 1.6px;
          background-color: #2c3e50;
          left: 0;
          bottom: -0.25rem;
          width: 100%;
          transform: scale(0);
          transition: transform .5s ease;
          transform-origin: left;
        }

        &:hover {
          &::after {
            transform: scale(1);
            height: 1.6px;
          }
        }

        &.selected {
          pointer-events: none;
          &::after {
            content: "";
            position: absolute;
            height: 1.6px;
            background-color: #2c3e50;
            bottom: -0.25rem;
            width: 100%;
            transform: scale(1);
          }
        }
      }

      @media (min-width: 400px) {
        justify-content: center;
        gap: 2.5rem;
      }

      @include for-tablet-landscape-up {
        gap: 7rem;
        margin-bottom: 3rem;

        button {
          font-size: 22px;
        }
      }
    }

    .price-section {
      display: flex;
      flex-direction: column;
    }

    h2 {
      font-size: 35px;
      margin-bottom: 0.5rem;
      padding-bottom: 0;
      font-family: Lato, sans-serif;
      font-weight: 400;
      text-transform: capitalize;
    }
    h3 {
      font-size: 30px;
    }
    .hidden {
      display: none;
    }

    @include for-tablet-portrait-down {
      h2 {
        font-size: 25px;
        padding-bottom: 0;
        font-family: Lato, sans-serif;
        font-weight: 400;
        text-transform: capitalize;
        line-height: 1;
        margin-bottom: 0;
      }
      h3 {
        font-size: 20px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
